import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { JSX } from 'react';
import type { Children } from '@repo/shared/types';
import { colorPalette } from '@repo/mui-config/color-palette';

interface TileLinkProps extends Children {
  link: string;
  icon: JSX.Element;
}

export const TileLink = ({ link, icon, children }: TileLinkProps) => {
  return (
    <Link href={link} underline="none">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '8px',
          backgroundColor: colorPalette.ice.dark,
          height: '76px',
          width: '100%',
          paddingX: '24px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '24px',
          }}
        >
          {icon}
          {children}
        </Box>
      </Box>
    </Link>
  );
};
